import React, { useEffect, useState } from 'react';
import Confirm from '../Dialog/Confirm';
import { opbcdtService, opbMngService } from '../../services';
import { alertActions } from '../../modules/alert';
import { useDispatch } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


export function ModBtn({ opbInfo, disabled, setSubmitted }) {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const handleOpen = () => {
        setOpen(!open);
    };

    const handleModButton = () => {

        setSubmitted();

        let formData = new FormData();
        formData.append("siteID", opbInfo.siteID);
        formData.append("opbID", opbInfo.opbID);
        opbcdtService.selectedOpb(formData)
            .then(response => {
                const connectYN = response.data.connectYN ? response.data.connectYN : "N";
                if (connectYN === "Y" && validation()) { modOpb(); }
                else if (connectYN === "Y") { return null; }
                else { dispatch(alertActions.error("Display 연결이 끊겼습니다. 확인 후 이용해주세요.")); }
            })
            .catch(handleErrors);
    };

    const validation = () => {
        const { opbName, boardCode, typeCode, floorStartType, floorStart, floorEnd, patchStandard, slotCode } = opbInfo;
        if (!opbName) {
            dispatch(alertActions.error("호기 이름은 필수 입력 값입니다."));
            return false;
        } else if (!boardCode || !typeCode) {
            dispatch(alertActions.error("타입은 필수 입력 값입니다."));
            return false;
        } else if (!floorStartType || (floorStartType === "지하" && parseInt(floorStart) === 0)) {
            dispatch(alertActions.error("최저층 정보는 필수 입력 값입니다."));
            return false;
        } else if (!floorEnd || parseInt(floorEnd) === 0) {
            dispatch(alertActions.error("최고층 정보는 필수 입력 값입니다."));
            return false;
        } else if (!patchStandard) {
            dispatch(alertActions.error("패치설정은 필수 입력 값입니다."));
            return false;
        } else if (!slotCode) {
            dispatch(alertActions.error("Display위치는 필수 입력 값입니다."));
            return false;
        } else
            return true;
    };

    const modOpb = () => {
        const { siteID, opbNo, opbID, opbName, floorStartType, floorStart, floorEnd, boardCode, typeCode, elvNo, patchStandard, slotCode, contractYN } = opbInfo;

        // 지상일 경우 무조건 10(1층을 의미함)부터 시작한다.
        // 지하일 경우 10에서 입력값을 뺀다.
        const newFloorStart = floorStartType === "지상" ? 10 : 10 - parseInt(floorStart);
        const opbStatus = contractYN === "Y" ? "ST001" : "ST002";

        let formData = new FormData();
        formData.append('siteID', siteID);
        formData.append('opbNo', opbNo);
        formData.append('opbID', opbID);
        formData.append("opbName", opbName);
        formData.append('floorStart', newFloorStart);
        formData.append('floorEnd', parseInt(floorEnd) + 9);
        formData.append('opbStatus', opbStatus);
        formData.append("boardCode", boardCode);
        formData.append("typeCode", typeCode);
        formData.append("elvNo", elvNo);
        formData.append("slotCode", slotCode);
        formData.append("patchStandard", patchStandard);

        opbMngService.modOpbInfo(formData)
            .then((response) => {
                if (response.status === 200) {
                    dispatch(alertActions.success("변경된 사항을 적용하였습니다."));
                    // this.props.stateRefresh();
                }
            })
            .catch(handleErrors);
    };

    const handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            dispatch(alertActions.error("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home"));
        else {
            if (error.response.status === 401)
                dispatch(alertActions.error("권한이 없습니다.", "/login"));
            else
                dispatch(alertActions.error(error.response.data.message));
        }
    };

    return (
        <>
            <button className={`button w100-button${disabled && " disabled-button"}`} variant="contained" color="primary" onClick={handleOpen} disabled={disabled}>수정</button>
            {open &&
                <Confirm message={"수정하시겠습니까?"} kind={"save"} handleFormSubmit={handleModButton} handleClose={handleOpen} />
            }
        </>
    );
};


export function CaptureBtn({ disabled, handleCaptureButton }) {
    const dispatch = useDispatch();


    const handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            dispatch(alertActions.error("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home"));
        else {
            if (error.response.status === 401)
                dispatch(alertActions.error("권한이 없습니다.", "/login"));
            else
                dispatch(alertActions.error(error.response.data.message));
        }
    };
    return (
        <button className="button w100-button s-width-auto" style={{ width: "110px" }} onClick={handleCaptureButton} disabled={disabled}>원격캡쳐요청</button>
    );
};


export function RefreshBtn({ disabled, handleRefreshButton }) {

    return (
        <button className={`button w100-button flower-blue-button${disabled ? " disabled-button" : ""}`} variant="contained" color="primary" onClick={handleRefreshButton} disabled={disabled}>새로고침</button>
    );
};


export function PreviewBtn({ className = "button w100-button", handleOpenPreview, disabled }) {

    return (
        <>
            <button className={`${className}`} variant="contained" onClick={handleOpenPreview}>
                <div>미리보기</div>
            </button>
        </>
    );
};

export function PublishBtn({ className = "button w100-button", opbInfo, userID, isToolTip, handleClose }) {
    const dispatch = useDispatch();

    const [state, setState] = useState({
        open: false,
        pubStatus: false,
        pubCount: 0,
        show: false
    });
    const { open, pubStatus, pubCount, show } = state;

    const handleShow = () => {
        setState({ ...state, show: !show });
    };
    const handleDervPubOpen = (pubType) => {
        opbInfo.pubType = pubType;
        handleOpen();
    };
    const handleOpen = () => {
        if (!pubStatus) setState({ ...state, open: !open });
    };

    const handleSubmitButton = () => {
        if (opbInfo.groupStatus && opbInfo.checkedOpbIDs.length === 0) {
            // 그룹배포 Display선택 여부 체크
            dispatch(alertActions.error("선택된 Display가 없습니다."));
        }
        else if (opbInfo.groupStatus && opbInfo.checkedOpbIDs.length > 0) {
            // 그룹배포
            opbInfo.checkedOpbIDs.map(checkedOpbID => handlePublish(checkedOpbID));
        }
        else if (!pubStatus) {
            // 개별배포
            handlePublish();
        }
    };

    const handlePublish = (checkedOpbID) => {
        let opbID = opbInfo.opbID;
        if (opbInfo.groupStatus === true) opbID = checkedOpbID;

        let formData = new FormData();
        formData.append("siteID", opbInfo.siteID);
        formData.append("opbID", opbID);
        opbcdtService.selectedOpb(formData)
            .then(response => {
                let paramOpbInfo = { ...opbInfo };
                const selectedOpbInfo = response.data;
                const connectYN = response.data.connectYN ? response.data.connectYN : "N";

                paramOpbInfo.userID = userID;
                paramOpbInfo.ip = "0:0:0:0:0:0:0:1";
                paramOpbInfo.pubReg = "user";
                paramOpbInfo.pubUser = userID;
                const config = paramOpbInfo.templateStatus || paramOpbInfo.floorsStatus || paramOpbInfo.bottomStatus ? "config" : "";
                const content = paramOpbInfo.promotionStatus || paramOpbInfo.marketingStatus || paramOpbInfo.bottomStatus ? "content" : "";
                paramOpbInfo.gbn = config && content ? "all" : (config || content ? config || content : "all");    // config / content / all

                if (opbInfo.groupStatus) {
                    paramOpbInfo.opbID = selectedOpbInfo.opbID;
                    paramOpbInfo.opbNo = selectedOpbInfo.opbNo;
                    paramOpbInfo.imei = selectedOpbInfo.imei;
                    paramOpbInfo.logContent = "opbID=" + selectedOpbInfo.opbID;
                }
                else {
                    paramOpbInfo.imei = (paramOpbInfo.imei ? paramOpbInfo.imei : "");
                    paramOpbInfo.logContent = "opbID=" + paramOpbInfo.opbID;

                    // floorID 설정
                    paramOpbInfo.floorsList = paramOpbInfo.floorsList.map(floor => {
                        floor.floorID = (floor.floorID === 0 ? -1 : floor.floorID);
                        return floor;
                    });
                }

                // promotion, marketing, bottom 설정
                paramOpbInfo.promotionList.map((promotion, i) => {
                    if (!promotion.startTime) promotion.startTime = "00:00:00";
                    if (!promotion.endTime) promotion.endTime = "23:59:59";
                    if (!promotion.contentVolume) promotion.contentVolume = 0;
                    promotion.sort = i + 1;
                    if (opbInfo.groupStatus) promotion.opbID = paramOpbInfo.opbID;
                    return promotion;
                });
                paramOpbInfo.marketingList.map((marketing, i) => {
                    if (!marketing.startTime) marketing.startTime = "00:00:00";
                    if (!marketing.endTime) marketing.endTime = "23:59:59";
                    if (!marketing.contentVolume) marketing.contentVolume = 0;
                    marketing.sort = i + 1;
                    if (opbInfo.groupStatus) marketing.opbID = paramOpbInfo.opbID;
                    return marketing;
                });
                paramOpbInfo.bottomList.map((bottom, i) => {
                    if (!bottom.startTime) bottom.startTime = "00:00:00";
                    if (!bottom.endTime) bottom.endTime = "23:59:59";
                    if (!bottom.contentVolume) bottom.contentVolume = 0;
                    bottom.sort = i + 1;
                    if (opbInfo.groupStatus) bottom.opbID = paramOpbInfo.opbID;
                    return bottom;
                });

                if (opbInfo.groupStatus) {
                    // deletaList 설정
                    if (paramOpbInfo.promotionStatus) selectedOpbInfo.promotionList.map(promotion => paramOpbInfo.deleteList.push(promotion.opbcontentID));
                    if (paramOpbInfo.marketingStatus) selectedOpbInfo.marketingList.map(marketing => paramOpbInfo.deleteList.push(marketing.opbcontentID));
                    if (paramOpbInfo.bottomStatus) selectedOpbInfo.bottomList.map(bottom => paramOpbInfo.deleteList.push(bottom.opbcontentID));
                }

                console.log("배포 버튼 클릭 후 paramOpbInfo 정보");
                console.log(paramOpbInfo);
                console.log(JSON.stringify(paramOpbInfo));

                // 배포 완료까지 배포 버튼 비활성화
                setState({ ...state, pubStatus: true, open: false });

                opbcdtService.setOpbState(JSON.stringify(paramOpbInfo))
                    .then(response2 => {
                        if (connectYN === "Y") {
                            formData = new FormData();
                            formData.append('imei', paramOpbInfo.imei);
                            formData.append('pubType', paramOpbInfo.pubType);
                            formData.append('pubReg', paramOpbInfo.pubReg);
                            formData.append('pubUser', paramOpbInfo.pubUser);
                            formData.append('gbn', paramOpbInfo.gbn);

                            opbcdtService.publishSend(formData)
                                .then(response3 => {
                                    // 모든 그룹배포 완료여부 확인
                                    console.log("연결Y 배포성공");
                                    handlePubCount();
                                })
                                .catch(error2 => {
                                    console.log("연결Y 배포실패");
                                    setState({ ...state, pubStatus: false });
                                    handleErrors(error2);
                                    dispatch(alertActions.error("배포 서버 오류 발생! 잠시 후 다시 이용해주세요."));
                                });
                        }
                        else {
                            // 모든 그룹배포 완료여부 확인
                            console.log("연결N");
                            handlePubCount();
                        }
                    })
                    .catch(error => {
                        setState({ ...state, pubStatus: false });
                        handleErrors(error);
                        dispatch(alertActions.error("배포(" + paramOpbInfo.imei + ") 실패하였습니다."));
                    });
            })
            .catch(handleErrors);
    };

    const handlePubCount = () => {
        setState((state) => {
            state = { ...state, pubCount: state.pubCount + 1 };
            return state;
        });
        if (pubCount + 1 === opbInfo.checkedOpbIDs.length) {
            handleClose();
        }
    };

    const handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            dispatch(alertActions.error("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home"));
        else {
            if (error.response.status === 401)
                dispatch(alertActions.error("권한이 없습니다.", "/login"));
            else
                dispatch(alertActions.error(error.response.data.message));
        }
    };

    return (
        <>
            <OverlayTrigger show={show} placement="top" overlay={
                <Tooltip className="" style={{ opacity: 1 }}>
                    <button className="button pubType-button derv" onClick={() => { handleDervPubOpen("derv"); }}>
                        <div>예약배포</div>
                    </button>
                    <button className="button pubType-button now" onClick={() => { handleDervPubOpen("now"); }}>
                        <div>즉시배포</div>
                    </button>
                </Tooltip>
            } >
                <button className={`${className}`} variant="contained" color="primary" onClick={isToolTip ? handleShow : handleOpen}>
                    <div>배포하기</div>
                </button>
            </OverlayTrigger>
            {open &&
                <Confirm message={(opbInfo.pubType === "derv" ? "예약" : "즉시") + "배포 하시겠습니까?"} kind={"save"} handleFormSubmit={handleSubmitButton} handleClose={handleOpen} />
            }
        </>
    );
};

export function CancelBtn({ className, validation, isMobile, handleClose }) {
    const [open, setState] = useState(false);

    const handleOpen = () => {
        if (validation) setState(!open);
        else handleClose();
    };

    return (
        <>
            {!isMobile
                ?
                <button className={`${className}`} variant="contained" color="primary" onClick={handleOpen}>
                    <div>취소하기</div>
                </button>
                :
                <div onClick={handleOpen}>
                    <img style={{ width: "15px", height: "15px" }} src="assets/images/screenMod/m-btn-close.svg" alt="X" />
                </div>
            }
            {open &&
                <Confirm message={"취소하시겠습니까?\n입력한 정보는 초기화됩니다."} kind="fail" handleFormSubmit={() => { handleClose(); }} handleClose={handleOpen} />
            }
        </>
    );
};

export function PrevBtn({ className, activeTabId, handleActiveTabIdChange }) {

    return (
        <>
            <button className={`${className}`} variant="contained" color="primary" onClick={() => { handleActiveTabIdChange(activeTabId - 1); }} >
                <div style={{width: "100%", textAlign: "center", marginRight: "30px"}}>이전</div>
            </button>
        </>
    );
};

export function NextBtn({ className, activeTabId, handleActiveTabIdChange }) {

    return (
        <>
            <button className={`${className} activeTabId-${activeTabId}`} variant="contained" color="primary" onClick={() => { handleActiveTabIdChange(activeTabId === 5 ? 3 : activeTabId + 1); }} >
                <div style={{width: "100%", textAlign: "center", marginLeft: "30px"}}>{activeTabId !== 5 ? "다음" : "완료"}</div>
            </button>
        </>
    );
};
